import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { ICouponServiceProps } from "@/api_framework/api_modals/coupon";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export interface ICouponCreationResponse {
  status: boolean;
  message: string;
  data: {
    coupon_id: string;
  };
}
export const useCouponCreationAPI = () => {
  const configuration = useConfiguration();
  const [coupon_id, setCoupon_id] = useState<string>(null);
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (filterParams: ICouponServiceProps) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(COUPON_SERVICE_APIS?.COUPON_CREATION?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICouponCreationResponse>) => {
            if (res.data.status === true) {
              setCoupon_id(res.data.data.coupon_id);
              toast.success("Coupon has been created.");
              return { status: true, message: res.data.data.coupon_id };
            } else {
              setCoupon_id(null);
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            setCoupon_id(null);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        setCoupon_id(null);
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
